import {
  MP_CHANGE_CURRENT_PROJECT_PAGE,
  MP_PROJECT_LAUNCH_LIST,
  MP_SEARCH_JOBS,
  MP_SET_PROJECT_ITEMS_PER_PAGE,
  MP_PROJECT_STATUS_FILTER,
  MP_RENEWAL_LOADER,
  MP_RENEWAL_LIST_SUCCESS,
  MP_RENEWAL_LIST_FAIL,
  MP_RENEWAL_ADD_SUCCESS,
  MP_RENEWAL_UPDATE_SUCCESS,
} from "../actions/mpLaunchesAction";

const initialState = {
  mpLaunchListing: [],
  mpLaunchTotalResults: null,
  mpLaunchTotalPages: null,
  mpLaunchPageIds: [],
  fetchingData: true,
  mpLaunchSearchText: "",
  mpLaunchCurrentPage: 1,
  mpLaunchListResultPerPage: 10,
  mpLaunchStatusFliter: [],
  renewalsList: [],
  renewalsLoading: false,
};

const mpLaunchesReducer = (state = initialState, action) => {
  switch (action.type) {
    case MP_PROJECT_LAUNCH_LIST: {
      return {
        ...state,
        mpLaunchListing: action.payload.results,
        mpLaunchTotalResults: action.payload.total_results,
        mpLaunchTotalPages: action.payload.total_pages,
        mpLaunchPageIds: action.payload.page_ids,
        fetchingData: false,
      };
    }

    case MP_CHANGE_CURRENT_PROJECT_PAGE: {
      return {
        ...state,
        mpLaunchCurrentPage: action.payload,
      };
    }

    case MP_SET_PROJECT_ITEMS_PER_PAGE: {
      return {
        ...state,
        mpLaunchListResultPerPage: action.payload,
      };
    }
    case MP_SEARCH_JOBS: {
      return {
        ...state,
        mpLaunchSearchText: action.payload,
      };
    }

    case MP_PROJECT_STATUS_FILTER: {
      return {
        ...state,
        mpLaunchStatusFliter: action?.payload || [],
      };
    }
    case MP_RENEWAL_LIST_SUCCESS:
      return { ...state, renewalsList: action.payload, renewalsLoading: false };
    case MP_RENEWAL_LIST_FAIL:
      return { ...state, renewalsList: [], renewalsLoading: false };
    case MP_RENEWAL_ADD_SUCCESS:
      return { ...state };
    case MP_RENEWAL_UPDATE_SUCCESS:
      return { ...state };
    case MP_RENEWAL_LOADER:
      return { ...state, renewalsLoading: true };
    default:
      return state;
  }
};

export default mpLaunchesReducer;
